import  './RectButton.scss';
import {FC, ReactNode} from 'react';
import {Link} from "react-router-dom";


interface IRectButton{
    type?: 'link' | 'button' | "htmlLink";
    name: ReactNode;
    className?: string;
    onClick?: ()=>void
    href?:string;
}

const RectButton:FC<IRectButton> = ({type="link",name,className='', onClick, href}) => {
    return (
        <div className={`btn-rect ${className}`}>
            {
            type === 'htmlLink' ? <a onClick={onClick} className={`btn-rect__wrapper`} target={"_blank"} href={href as string}><span>{name}</span></a>
            :
            type === 'button' ?
            <button type={'submit'} onClick={onClick} className={`btn-rect__wrapper`}>
                <span> {name}</span>
            </button>
            :
            <Link onClick={onClick} className={`btn-rect__wrapper`} to={href as string}>
                <span>{name}</span>
            </Link>
            }
        </div>
    );
};

export default RectButton;